import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {setSubscriptionsInfo, toggleCreditCardPopup, toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField} from "../FormField";
import {AccessRights, PARTS} from "../../../schemas/accessRightsModel";
import SimpleDropDown from "../../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";
import Subscription from "../Subscription";
import misc from "../../../misc";
import {errorBox_Show, messageBoxEx_Show} from '../../../actions/A_Popups';
import {setSubscriptionId, showESignatureOverlay} from "../../AddNewEntity/AddNewEntityActions";
import {store} from "../../../main";



class ToolSubscription extends Subscription {

  componentDidMount() {
    document.addEventListener('cancel-esignature-overlay', this.cancelEsOverlayListener);
  }

  componentWillUnmount() {
    document.removeEventListener('cancel-esignature-overlay', this.cancelEsOverlayListener);
  }

  componentWillReceiveProps(nextProps) {
    const {subscriptionsInfo, tool} = nextProps;
    const subscriptionId = nextProps[`${tool}SubscriptionId`];
    const TOOL = tool[0].toUpperCase() + tool.substring(1);
    // if(TOOL == "Kitchen")
    //   console.log(nextProps, subscriptionId, TOOL);

    if (subscriptionId > 0 && subscriptionsInfo[`${tool}PaymentType`] && subscriptionsInfo[`${tool}PaymentType`] != 'Select'
        && subscriptionsInfo[`${tool}PaymentType`].id !== subscriptionId) {
      const sub = nextProps.subscriptions.find(s => s.id === subscriptionId);
      if (sub) {
        const paymentTypes = this.getPaymentTypes(tool, sub.type, nextProps, sub.id);
        const paymentType = paymentTypes.find(pt => pt.id === subscriptionId);
        this.props.setSubscriptionsInfo({
          [`${tool}ProgramType`]: subscriptionId > 0 ? sub.type : "Select",
          [`${tool}PaymentType`]: subscriptionId > 0 ? paymentType : "Select Program",
          [`initial${TOOL}ProgramType`]: subscriptionId > 0 ? sub.type : "Select",
          [`initial${TOOL}PaymentType`]: subscriptionId > 0 ? paymentType : "Select Program"
        });
      }
    }
  }

  cancelEsOverlayListener = () => {
    const {subscriptionsInfo, tool} = this.props;
    const TOOL = tool[0].toUpperCase() + tool.substring(1);
    if(this.state.showingESignFor == tool)
    {
      this.props.setSubscriptionsInfo({
        [`${tool}PaymentType`]: subscriptionsInfo[`initial${TOOL}PaymentType`],
        [`${tool}ProgramType`]: subscriptionsInfo[`initial${TOOL}ProgramType`]
      });
    }
  };

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value))
  };

  render() {
    const {AR, subscriptionsInfo, tool} = this.props;
    const TOOL = tool[0].toUpperCase() + tool.substring(1);
    const {entityId, isMasterFabricator, canEditFields} = this.props.accountPageInfo;
    const {subscriptionEditable} = this.props.formValues;
    const sub = this.props.subscriptions.find((s) => {
      return subscriptionsInfo[`${tool}PaymentType`] && (s.id === subscriptionsInfo[`${tool}PaymentType`].id)
    }) || {}
    let activeProgramType = "Select";
    let activePaymentType = "Select";
    if(subscriptionsInfo[`${tool}ProgramType`])
      activeProgramType = subscriptionsInfo[`${tool}ProgramType`];
    if(subscriptionsInfo[`${tool}PaymentType`])
      activePaymentType = subscriptionsInfo[`${tool}PaymentType`];

       // console.log(tool, subscriptionsInfo);
    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS[`${tool}_subscription`])}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS[`${tool}_subscription`])}
                     title={`${TOOL} Subscription`}>
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              {AR.isSiteAdmin(false) || !entityId ? ( // if account is new - do not show this toggle
                <Field name="subscriptionEditable" component={FormCheckBoxField} doubleMargin={true}
                       onChecked={this.updateCheckBoxField} labelEnabled="Subscription Editable"
                       labelDisabled="Subscription Editable"/>
              ) : null}
              {this.props.subscriptions.length ? (
                <div className="acc-checkbox">
                  {isMasterFabricator ? (
                    <SimpleDropDown id={`${tool}-program-type`}
                                    disabled={!subscriptionEditable}
                                    values={this.getProgramTypes(subscriptionsInfo[`initial${TOOL}ProgramType`], tool)}
                                    activeValue={activeProgramType} label="Program Type"
                                    onChange={(value) => this.updateProgramType(tool, value)}/>
                  ) : <p>{subscriptionsInfo[`${tool}ProgramType`]}</p>}
                </div>
              ) : null}
              {this.props.subscriptions.length ? (
                <div className="acc-checkbox">
                  {isMasterFabricator ? (
                    <SimpleDropDown id={`${tool}-payment-type`}
                                    disabled={!subscriptionEditable || !this.getPaymentTypes(tool).length}
                                    values={this.getPaymentTypes(tool)}
                                    activeValue={activePaymentType} label="Payment Type"
                                    onChange={(value) => this.updatePaymentType(tool, value)}/>
                  ) : <p>{subscriptionsInfo[`${tool}PaymentType`].text}</p>}
                </div>
              ) : null}
              {tool == "kitchen" && isMasterFabricator && AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_QUOTING) ? (
                <Field name="enableQT" component={FormCheckBoxField} doubleMargin={true}
                       disabled={!canEditFields || AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_QUOTING)}
                       onChecked={this.updateCheckBoxField} labelEnabled="Enable Quoting"
                       labelDisabled="Enable Quoting"/>
              ) : null}
              {tool == "kitchen" && isMasterFabricator && AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_VISUALIZATION) ? (
                <Field name="enableKV" component={FormCheckBoxField} doubleMargin={true}
                       onChecked={this.updateCheckBoxField} labelEnabled="Enable Visualization"
                       disabled={!canEditFields || AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_VISUALIZATION)}
                       labelDisabled="Enable Visualization"/>
              ) : null}
            </div>
            {this.getSubscriptionInfo(sub)}
          </div>
        </div>
      </ExpandSection>
    )
  }
}

const mapStateToProps = (store, props) => {
  const {sectionsOpened, accountPageInfo, subscriptionsInfo, billingInformation} = store.accountState;
  const {customerInfo, subscriptions, fabricatorSubscriptions} = store.newaccount;
  const {tool} = props;
  // console.log(fabricatorSubscriptions, store.newaccount);
  return {
    sectionsOpened,
    accountPageInfo,
    subscriptionsInfo,
    AR: AccessRights.get(store),
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
    [`${tool}SubscriptionId`]: misc.monads.NN((fabricatorSubscriptions || {})[tool], _ => _.id, 0),
    subscriptions,
    paymentProfile: customerInfo.paymentProfile,
    saveCC: billingInformation.saveCC
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  setSubscriptionsInfo,
  messageBoxEx_Show,
  toggleCreditCardPopup,
  showESignatureOverlayFn: showESignatureOverlay,
  setSubscriptionId
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolSubscription);

